module.exports = __webpack_public_path__ + "static/cka-2fd712560474a16b7e1f830bf50850e8.png";